const HOST = process.env.API_HOST || 'https://vima-ai.com';
const DEFAULT_API_VERSION = 'api/v1';

export const buildEndpointIntranetAdmin = (path: string, version: string = DEFAULT_API_VERSION) =>
    `${HOST}/${version}/intranet-admin/${path}`;
export const buildEndpointIntranetCompany = (path: string, version: string = DEFAULT_API_VERSION) =>
    `${HOST}/${version}/intranet-company/${path}`;
export const buildEndpointShared = (path: string, version: string = DEFAULT_API_VERSION) =>
    `${HOST}/${version}/shared/${path}`;
